import strFunc from "@/lib/lyg/string";
import { useNavigate } from "react-router";

function ManageBtnArea(props: any) {
  let myProps = {
    order_det_arr: [],
    select_order_det_seq_arr: [],
    set_select_order_det_seq_arr: (inData: any) => { },
    is_show_all_book:false,
    set_is_show_all_book: (inData: any) => { },
    open_request_order_popup: (inData: any) => { },
    open_pay_by_det_popup: (inData: any) => { },
    open_charge_point_popup: (inData: any) => { },
    ...props
  };
  const navigate = useNavigate();

  const check_all_ready_order_det = (e: any) => {
    let ready_order_det_arr: any = [];
    let ready_order_det_seq_arr: any = [];

    for (let i = 0; i < myProps.order_det_arr.length; i++) {
      let order_det = myProps.order_det_arr[i];
      if (order_det.par_order_state == "ready") {
        ready_order_det_arr.push(order_det);
        ready_order_det_seq_arr.push(order_det["a_ymd"] + "," + order_det["a_seq"]);
      }
    }
    if (e.target.checked) {
      myProps.set_select_order_det_seq_arr(ready_order_det_seq_arr);
    } else {
      myProps.set_select_order_det_seq_arr([]);
    }
  }

  let checked_cost = 0;
  let select_order_det_arr: any = [];
  for (let i = 0; i < myProps.order_det_arr.length; i++) {
    let order_det = myProps.order_det_arr[i];
    if (order_det.par_order_state == "ready") {
      let tmp_pri_val = order_det["a_ymd"] + "," + order_det["a_seq"];
      if (strFunc.str_in_array(tmp_pri_val, myProps.select_order_det_seq_arr) != -1) {
        checked_cost += parseInt(strFunc.uncomma(order_det.a_price));
        checked_cost += parseInt(strFunc.uncomma(order_det.a_price_tax));
        select_order_det_arr.push(order_det);
      }
    }
  }

  return (
    <div>
      <div>
        <label>
          <input type="checkbox" checked={myProps.is_show_all_book} 
            onChange={(e:any)=>{
              myProps.set_is_show_all_book(e.target.checked);
            }} />
            <span className="ml-1">교재사용모두보기</span>
        </label>
      </div>
      <div className="my_flex_right mt-1">
        남은 포인트: <span style={{color:"red"}}>{strFunc.comma(myProps.mcomp_point)}</span>P
        <button className="btn btn-dark ml-1"
          onClick={()=>{
            myProps.open_charge_point_popup({});
          }}
        >충전</button>
        <button className="btn btn-dark ml-1"
          onClick={()=>{
            navigate("/comp/book_order/shop/order/comp_book_list");
          }}
        >주문이력</button>
      </div>
      <div className="my_flex_right mt-1">
        <button className="btn btn-sky"
          onClick={() => {
            myProps.open_request_order_popup({});
          }}>일괄신청</button>

        <span style={{ position: "relative", marginLeft: 5 }}>
          {checked_cost > 0 &&
            <span style={{ position: "absolute", left: 20, bottom: -35, display: "inline-block", minWidth: 100, color: "#555" }}>
              ({strFunc.comma(checked_cost)} 원)
            </span>
          }
        </span>
        <label className="ml-2">
          <input type="checkbox"
            onChange={(e) => {
              check_all_ready_order_det(e);
            }}
          /> 주문 선택
        </label>
        <button className="btn btn-blue ml-1"
          onClick={() => {
            myProps.open_pay_by_det_popup({
              select_order_det_arr: select_order_det_arr
            });
          }} >선택결제</button>
      </div>
    </div>
  );
};
export default ManageBtnArea;